import { Checkbox, InputAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement, ReactNode, useLayoutEffect, useRef } from "react";
import { useController, useFormContext } from 'react-hook-form';

export interface CheckboxFieldRules {
  required?: boolean;
  disabled?: boolean;
}

export interface CheckboxFieldProps {
  name: string;
  label: ReactNode;
  rules?: CheckboxFieldRules;
  onChange?(e: React.SyntheticEvent<HTMLElement>): void;
  children?: ReactNode;
}

export function CheckboxField({ name, children, rules, onChange, label, ...rest }: CheckboxFieldProps): ReactElement {
  let controlContext;
  try {
    controlContext = useFormContext();
  } catch {
  }
  const checkboxRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (!checkboxRef.current) return;

    const input = checkboxRef.current.querySelector('input[type="checkbox"]');
    if (input && input.nextElementSibling) {
      const focusWrapper = input.nextElementSibling as HTMLElement;
      focusWrapper.style.alignItems = 'center';
    }
  }, []);


  if (!controlContext) {
    return (
      <div ref={checkboxRef}>
        <Checkbox
          onChange={onChange}
          name={name}
          value="false"
          {...rules}
          {...rest}
        />
      </div>
    );
  }
  const { control } = controlContext;

  const {
    field: { onChange: onFieldChange, onBlur, value },
    fieldState: { invalid, error },
    formState: { isSubmitted },
  } = useController({
    name,
    control,
  });

  const showError = isSubmitted && invalid;
  const errorMessage = showError ? error?.message : undefined;
  const appearanceError = showError ? InputAppearance.Error : undefined;

  return (
    <div ref={checkboxRef}>
      <Checkbox
        message={errorMessage}
        appearance={appearanceError}
        onChange={(e) => {
          onFieldChange(e);
          onChange?.(e);
        }}
        onBlur={onBlur}
        value={value ? 'true' : 'false'}
        name={name}
        checked={value}
        label={label}
        {...rules}
        {...rest}
      />
    </div>
  );
}
